import { combineReducers } from "redux";
import userReducer from "./User"

const Reducers = combineReducers({
  CurrentUser: userReducer,
});

export default Reducers;
